import { IBlacksInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const blacksSelector = (state: RootState) => state.blacks;

const blacksListSelector = createSelector([blacksSelector], (blacks: IBlacksInitialState) => blacks.blacksList);

const blackSelector = createSelector([blacksSelector], (blacks: IBlacksInitialState) => blacks.black);

export const blacksSel = {
    blacksSelector,
    blackSelector,
    blacksListSelector,
};
